namespace Gamification.Gamification {
    export namespace AssetEsperienzeRisorseService {
        export const baseUrl = 'Gamification/AssetEsperienzeRisorse';

        export declare function Create(request: Serenity.SaveRequest<AssetEsperienzeRisorseRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<AssetEsperienzeRisorseRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<AssetEsperienzeRisorseRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AssetEsperienzeRisorseRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/AssetEsperienzeRisorse/Create",
            Update = "Gamification/AssetEsperienzeRisorse/Update",
            Delete = "Gamification/AssetEsperienzeRisorse/Delete",
            Retrieve = "Gamification/AssetEsperienzeRisorse/Retrieve",
            List = "Gamification/AssetEsperienzeRisorse/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>AssetEsperienzeRisorseService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
